import React, { Component } from 'react';
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../utils/withRouter";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { connect } from "react-redux";
import { toastError, countryActionId, cityActionId, industryActionId, stateActionId, downloadReport, toastSuccess, sessionExpireMessage, tokenInavlidMessage, } from '../../../utils/constants'
import { fill_action } from '../../../actions/fillCombo_action'
import Pagination from "../../../utils/pagination";
import Header from '../../../common_components/Header';
import { get_taxInvoiceList_action, taxInvoiceRpt_action, share_taxInvoice_action } from '../../../actions/adminAction/taxInvoice_action';
import moment from 'moment';
import Loader from '../../../utils/Loader';

class taxInvoiceList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isOtherPreName: false, isFilterShow: false,
            MemberID: '', currentPage: 1, recordsPerPage: 10, invoiceList: [],
            isAllChecked: false,
            CompanyName: '', TaxInvoice_No: '', Membershipno: '', FullAccess: false, ReadAccess: false, WriteAccess: false, UpdateAccess: false, DeleteAccess: false, DownloadAccess: false, Is_SpecialAccess: false, SendAccess: false
        }
        this.updateItem = this.updateItem.bind(this);
        this.updateRecordsPerPage = this.updateRecordsPerPage.bind(this);

    }

    componentDidMount() {
        if (JSON.parse(sessionStorage.getItem("loginDataSS")) == null) {
            setTimeout(() => {
                this.props.navigate('/');
            }, 200);
        } else {
            window.scrollTo(0, 0)
            const loginAccessList = JSON.parse(sessionStorage.getItem('loginAccesslist')) || [];
            const InvoiceListModule = loginAccessList.find(module => module.ModuleName === "Tax Invoice List");

            if (InvoiceListModule) {
                const { FullAccess, ReadAccess, WriteAccess, UpdateAccess, DeleteAccess, DownloadAccess, Is_SpecialAccess, SendAccess } = InvoiceListModule;

                if (!FullAccess && !ReadAccess) {
                    this.props.navigate('/login'); // Navigate to login if no access
                } else {
                    this.setState({
                        FullAccess: !!FullAccess,
                        ReadAccess: !!ReadAccess,
                        WriteAccess: !!WriteAccess,
                        UpdateAccess: !!UpdateAccess,
                        DeleteAccess: !!DeleteAccess,
                        DownloadAccess: !!DownloadAccess,
                        Is_SpecialAccess: !!Is_SpecialAccess,
                        SendAccess: !!SendAccess
                    });

                    if (FullAccess) {
                        this.setState({
                            ReadAccess: true,
                            WriteAccess: true,
                            UpdateAccess: true,
                            DeleteAccess: true,
                            DownloadAccess: true,
                            Is_SpecialAccess: true,
                            SendAccess: true
                        });
                    }
                }
            } else {
                this.props.navigate('/login');
            }

            if (loginAccessList.length) {
                this.getFillList(countryActionId, '', '', '', '').then(() => {
                    this.getFillList(industryActionId, '', '', '', '').then(() => {
                        this.getTaxInvoiceList()
                    })
                })
            }
        }
    }

    getFillList(actionID, ModuleID, KeyValue, Value, UserID) {
        this.setState({ isLoading: true })
        return new Promise((resolve, reject) => {
            this.props
                .fill_action(actionID, ModuleID, KeyValue, Value, UserID)
                .then((data) => {
                    if (data.error != 1) {
                        if (actionID === countryActionId) {
                            this.setState({ countryList: data.data })
                            resolve(true)
                        }
                        else if (actionID === stateActionId) {
                            data.data.length > 0 && this.setState({
                                stateList: data.data,
                                tempStateList: data.data,
                            })
                            resolve(true)
                        }
                        else if (actionID === cityActionId) {
                            data.data.length > 0 && this.setState({
                                cityList: data.data,
                                tempCityList: data.data,
                            })
                            resolve(true)
                        }
                        else if (actionID === industryActionId) {
                            this.setState({
                                industryList: data.data,
                                // tempCityList: data.data,
                            })
                            resolve(true)
                        }
                    }
                })
        })
    }
    onInvoiceDownload(E, id) {
        this.setState({ isLoading: true })
        this.props.taxInvoiceRpt_action(id)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false })
                    console.log("Proforma Pdf Download", data)
                    var url = `${downloadReport}?SessionIdentifier=${data}&Export=true`;
                    const win = window.location.replace(url, '_blank');
                    if (win != null) {
                        win.focus();
                    }
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })

    }
    getTaxInvoiceList() {
        const { isLoading, CompanyName, TaxInvoice_No, Membershipno } = this.state
        this.setState({ isLoading: true })
        console.log(CompanyName, TaxInvoice_No, Membershipno, 'before action')
        this.props
            .get_taxInvoiceList_action(CompanyName, TaxInvoice_No, Membershipno)
            .then((data) => {
                console.log(data)
                if (data.error != 1) {
                    const updatedInvoiceList = data.data.map(invoice => ({
                        ...invoice,
                        isChecked: 0,
                    }));

                    this.setState({
                        invoiceList: updatedInvoiceList,
                        isLoading: false
                    });
                }
                else {
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear();
                        this.props.navigate("/");
                        setTimeout(() => {
                            toastError(data.msg);
                        }, 2000);
                    } else {
                        toastError(data.data);
                    }
                    this.setState({ isLoading: false })
                    toastError(data.data.ErrorMsg);
                }
            }).catch((e) => {
                console.log(e);
                this.setState({ isLoading: false });
            });
    }
    clearFilter() {
        this.setState({ CompanyName: '', Membershipno: '', TaxInvoice_No: '' }, () => this.getTaxInvoiceList())
    }
    navigateUserView() {
        this.props.navigate('/user_details')
    }
    updateItem = (item) => {
        this.setState({ currentPage: item });
    };
    updateRecordsPerPage = (count) => {
        this.setState({ recordsPerPage: count, currentPage: 1 }, () => window.scrollTo(0, 0));
    };
    handleAllSelected(e) {
        const { invoiceList, isAllChecked } = this.state
        invoiceList.map(data => {
            if (!data.is_checked) {
                data.is_checked = 1
            } else {
                data.is_checked = 0
            }
        })
        this.setState({ invoiceList: invoiceList, isAllChecked: !isAllChecked })

        const checkboxSelected = invoiceList.every(item => item.is_checked == 1)
        if (checkboxSelected) {
            this.setState({ checkBoxFlag: false })
        } else {
            this.setState({ checkBoxFlag: true })
        }
    }
    handleListClick(e, id) {
        const { invoiceList, isAllChecked } = this.state
        var list = []
        invoiceList.map((data, index) => {
            if (data.TaxInvoiceID === id) {
                if (!data.is_checked) {
                    data.is_checked = 1
                } else {
                    data.is_checked = 0
                    this.setState({ isAllChecked: false })
                }
            }
        })

        this.setState({ invoiceList: invoiceList })
        const checkboxSelected = invoiceList.some(item => item.is_checked == 1)
        if (checkboxSelected) {
            this.setState({ checkBoxFlag: false })
        } else {
            this.setState({ checkBoxFlag: true })
        }

        const allSelected = invoiceList.every(item => item.is_checked == 1)

        if (allSelected) {
            this.setState({ isAllChecked: true })
        } else {
            this.setState({ isAllChecked: false })
        }

    }
    taxInvoiceRecord(invoiceList) {
        const { isAllChecked, ReadAccess, WriteAccess, UpdateAccess, DeleteAccess, DownloadAccess, SendAccess, Is_SpecialAccess } = this.state
        return (
            <table className="table table-bordered table-striped mg-b-0">
                <thead>
                    <tr>
                        {/* {(JSON.parse(sessionStorage.getItem('loginDataSS')).RoleName == 'Super Admin' || JSON.parse(sessionStorage.getItem('loginDataSS')).RoleName == 'Admin') && <>
                            <th className="text-center">
                                <input type="checkbox" class="custom-control-input" value={isAllChecked} checked={isAllChecked} />
                                <label style={{ marginTop: 0, paddingLeft: '10px', marginBottom: '1.5em' }} class="custom-control-label" onClick={(e) => this.handleAllSelected(e)}></label>
                            </th>
                        </>} */}
                        <th>Registration No</th>
                        <th>Company Name</th>
                        <th>Tax Invoice No</th>
                        <th>Date</th>
                        <th>Amount</th>
                        <th>Type</th>
                        <th className="text-right" style={{ width: "10%" }} />
                    </tr>
                </thead>
                <tbody id="myTable">
                    {invoiceList.length > 0 ? invoiceList.map((data, i) => (
                        <tr>
                            {/* {(JSON.parse(sessionStorage.getItem('loginDataSS')).RoleName == 'Super Admin' || JSON.parse(sessionStorage.getItem('loginDataSS')).RoleName == 'Admin') && <>
                                <td className="text-center" style={{ paddingRight: '20px' }}>
                                    <input type="checkbox" class="custom-control-input" value={data.is_checked} checked={data.is_checked} onClick={(e) => this.handleListClick(e, data.TaxInvoiceID)} />
                                    <label onClick={(e) => this.handleListClick(e, data.TaxInvoiceID)} class="custom-control-label" style={{ marginTop: 0, paddingLeft: '10px', marginBottom: '1.5em' }} ></label>
                                </td>
                            </>} */}
                            <td>{data.MembershipNo}</td>
                            <td>{data.CompanyName}</td>
                            <td>{data.TaxInvoice_No}</td>
                            <td>{moment(data.TaxInvoice_Date).format('DD-MMM-yyyy')}</td>
                            <td>{data.Total_Payable?.toLocaleString('en-US')}</td>
                            <td>{data.ServiceName}</td>
                            <td className="text-center" style={{ width: '5%' }}>
                                {DownloadAccess && <>
                                    <a
                                        // href="javascript:void(0);"
                                        onClick={(e) => this.onInvoiceDownload(e, data.MemberID)}
                                        title="View Invoice"
                                        className="load_document_icon mx-2"
                                        data-toggle="modal"
                                        data-target="#add_comment_modal"
                                    >
                                        <i className="fa fa-eye" />
                                    </a>
                                </>}
                                {SendAccess && <>
                                    {(JSON.parse(sessionStorage.getItem('loginDataSS')).RoleName == 'Super Admin' || JSON.parse(sessionStorage.getItem('loginDataSS')).RoleName == 'Admin') ? <>
                                        <a
                                            href="javascript:void(0);"
                                            title="Send"
                                            onClick={() => this.shareTaxInvoice(data.MemberID, data.TaxInvoice_No, data.ContactPersonName, data.EmailAddress)}
                                            className="load_document_icon  p-1 pb-2 px-2 send_credentials-btn mx-1"
                                            data-toggle="modal"
                                            data-target="#add_comment_modal"
                                        >
                                            Send
                                        </a>
                                    </> : <></>}
                                </>}
                            </td>
                        </tr>
                    )) : (
                        <tr>
                            <td colSpan={8}>No Record Found</td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }
    toggleFilterCollapse() {
        this.setState((prevstate) => ({
            isFilterShow: !prevstate.isFilterShow
        }))
    }
    shareTaxInvoice(MemberID, TaxInvoice_No) {
        this.setState({ isLoading: true })
        this.props
            .share_taxInvoice_action(MemberID, TaxInvoice_No)
            .then((data) => {
                console.log(data)
                if (data.error != 1) {
                    this.setState({ isLoading: false }, () => toastSuccess(data.data))
                } else {
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear();
                        this.props.navigate("/");
                        setTimeout(() => {
                            toastError(data.msg);
                        }, 2000);
                    } else {
                        toastError(data.data);
                    }
                    this.setState({ isLoading: false })
                    toastError(data.data.ErrorMsg);
                }
            }).catch((e) => {
                console.log(e);
                this.setState({ isLoading: false });
            });
    }
    render() {
        const { isLoading, CompanyName, currentPage, invoiceList, isFilterShow, TaxInvoice_No, Membershipno, recordsPerPage,
            FullAccess, ReadAccess, WriteAccess, UpdateAccess, DeleteAccess, DownloadAccess, Is_SpecialAccess, SendAccess } = this.state
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
        const currentRecords = invoiceList.slice(
            indexOfFirstRecord,
            indexOfLastRecord
        );
        const nPages = Math.ceil(invoiceList.length / recordsPerPage);
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                    // <></>
                ) : (
                    null
                )}
                {/* <ToastContainer />. */}
                <Header />
                <ToastContainer />
                <section class="registration_form">
                    <div class="container">
                        <div class="row mt-15">
                            <section className="table_section">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-12 col-sm-12 col-lg-12">
                                            <div className="card shadow-none border mb-2" >
                                                <div className="card-header py-1">
                                                    <h6 className='pt-2' style={{ float: 'left' }}>Tax Invoice</h6>
                                                    {(JSON.parse(sessionStorage.getItem('loginDataSS')).RoleName == 'Super Admin' || JSON.parse(sessionStorage.getItem('loginDataSS')).RoleName == 'Admin') ? <>
                                                        <a style={{ float: 'right' }}
                                                            href="javascript:void(0);"
                                                            className="btn btn-purple custom_btn"
                                                            title="Filter"
                                                            data-toggle="modal"
                                                            data-target="#filter_modal"
                                                            onClick={() => this.toggleFilterCollapse()}
                                                        >
                                                            <i className="fa fa-filter" />
                                                        </a>

                                                    </> : <></>}
                                                </div>
                                                <ul className="list-group list-group-flush" >
                                                    {isFilterShow && <>

                                                        <li className="list-group-item"><div className="row">
                                                            <div class="col-md-3">
                                                                <div class="form-group">
                                                                    <label>Registration No<span className="red-star text-danger">*</span></label>
                                                                    <input type="text" class="form-control" placeholder="Enter Registration No" value={Membershipno} onChange={(e) => this.setState({ Membershipno: e.target.value })} maxLength={1000} />

                                                                </div>
                                                            </div>
                                                            <div class="col-md-3">
                                                                <div class="form-group">
                                                                    <label>Company Name<span className="red-star text-danger">*</span></label>
                                                                    <input type="text" class="form-control" placeholder="Enter Company name" value={CompanyName} onChange={(e) => this.setState({ CompanyName: e.target.value })} maxLength={1000} />

                                                                </div>
                                                            </div>
                                                            <div class="col-md-3">
                                                                <div class="form-group">
                                                                    <label>Tax Invoice No<span className="red-star text-danger">*</span></label>
                                                                    <input type="text" class="form-control" placeholder="Enter Tax Invoice No" value={TaxInvoice_No} onChange={(e) => this.setState({ TaxInvoice_No: e.target.value })} maxLength={1000} />

                                                                </div>
                                                            </div>
                                                            <div className="col-xl-2 mb-3">
                                                                < button style={{ marginTop: '20px' }} className='btn btn-primary mr-2' onClick={() => this.getTaxInvoiceList()}>
                                                                    Search
                                                                </button>
                                                                <button type="button" style={{ marginTop: '20px' }} className='btn btn-dark mr-2 ms-2' onClick={e => this.clearFilter()}>
                                                                    Clear
                                                                </button>
                                                            </div>
                                                        </div></li>
                                                    </>}
                                                </ul>
                                            </div>
                                            <div className="card shadow-none border">

                                                <div className="card-body p-2 pb-0">

                                                    <div className="custom_table">
                                                        <div className="hack1">
                                                            <div className="hack2">
                                                                {this.taxInvoiceRecord(currentRecords)}
                                                                {invoiceList.length > 0 ? (
                                                                    <Pagination
                                                                        nPages={nPages}
                                                                        currentPage={currentPage}
                                                                        setCurrentPage={this.updateItem}
                                                                        totalRecords={invoiceList.length}
                                                                        pageLength={recordsPerPage}
                                                                        setPageLength={this.updateRecordsPerPage}
                                                                    />
                                                                ) : (
                                                                    <></>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>

                        </div>

                    </div >
                </section >
                {/* <Footer /> */}

            </>
        )
    }
}

export default withRouter(connect(null, { fill_action, get_taxInvoiceList_action, taxInvoiceRpt_action, share_taxInvoice_action })(taxInvoiceList));
